// extracted by mini-css-extract-plugin
export default {"contentBlock":"PrimaryContent_contentBlock"};